import { render, staticRenderFns } from "./detailsa.vue?vue&type=template&id=46bf9094&scoped=true&"
import script from "./detailsa.vue?vue&type=script&lang=js&"
export * from "./detailsa.vue?vue&type=script&lang=js&"
import style0 from "./detailsa.vue?vue&type=style&index=0&id=46bf9094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf9094",
  null
  
)

export default component.exports